import { CRM_SYSTEMS_IDS, DEFAULT_CRM_SYSTEM } from "@/features/crm_system/lib/_core/crmSystem/crmSystem.constants.gen";
import { fieldNumberSchema } from "@/lib/schema/common";
import { questionSelectedConfigurationSchema } from "@/lib/schema/configuration/configuration";
import { fieldDateOptionsSchema, fieldOptionsSchema } from "@/lib/schema/question";
import { TablesInsert } from "@/lib/supabase/supabase_types_override";
import { z } from "zod";

export const questionBankFormSchema = z.object({
    id: z.string().optional(),
    question: z.string().min(1, {message: "Question is required"}),
    // question_bank_ref_id: z.string().optional(),
    description: z.string().optional(),
    field_type: z.string().min(1, {message: "Field is required"}),
    crm_system: z.enum(CRM_SYSTEMS_IDS).optional().default(DEFAULT_CRM_SYSTEM),
    crm_field_name: z.string().optional(),
    field_options: fieldOptionsSchema,
    field_placeholder: z.string().optional().nullable().default(null),
    field_date_options: fieldDateOptionsSchema.optional().nullable().default(null),
    field_min: fieldNumberSchema.default(null),
    field_max: fieldNumberSchema.default(null),
    field_decimal_places: fieldNumberSchema.default(null),
    field_integer_places: fieldNumberSchema.default(null),
    field_step: fieldNumberSchema.default(null),

    // TODO: check why without nullable() it doesn't work
    field_min_label: z.string().optional().nullable().default(null),
    field_max_label: z.string().optional().nullable().default(null),
    field_label: z.string().optional().nullable().default(null),

    field_default_value: z.union([z.string(), z.number()]).nullable().optional(),
    selected_configuration: questionSelectedConfigurationSchema.optional().nullable().default(null),
}) satisfies z.ZodType<TablesInsert<'question_bank'>>
